import { Nav } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../components/auth/useAuth'
import { NavLink } from 'react-router-dom'

export default function Sidebar() {
    const { t } = useTranslation()
    const { clientauth } = useAuth()

    return (
        <div className='sidebar d-flex flex-column pt-3'>
            <div className='sidebar-logo d-flex align-items-center justify-content-center'>
                <img src="/images/logotipo-albany.png" alt="Logotipo Albany" width={60} className='logo-sidebar' />
                <div className='mx-3'>
                    <h5 className='fw-bold text-black'>Albany School</h5>
                    <p className='text-muted mb-0'>{t('admin.dashboard.studentportal')}</p>
                </div>
            </div>

            <hr className='mb-0'></hr>

            <Nav className='flex-column mt-4 px-3 gap-2'>
                <Nav.Link as={NavLink} to='/teacher/dashboard' className='sidebar-link'>
                    <div className='d-flex'>
                        <img src="/images/home.svg" alt="Home" className='me-3' />
                        <div>
                            <p className='mb-0 fw-bold'>{t('teacher.sidebar.dashboard')}</p>
                            <p className='mb-0 text-muted small'>{t('teacher.sidebar.dashboarddescription')}</p>
                        </div>
                    </div>
                </Nav.Link>
                <Nav.Link as={NavLink} to='/teacher/classes' className='sidebar-link'>
                    <div className='d-flex'>
                        <img src="/images/openbook.svg" alt="classes" className='me-3' />
                        <div>
                            <p className='mb-0 fw-bold'>{t('teacher.sidebar.classes')}</p>
                            <p className='mb-0 text-muted small'>{t('teacher.sidebar.classesdescription')}</p>
                        </div>
                    </div>
                </Nav.Link>
                <Nav.Link as={NavLink} to='/teacher/groups' className='sidebar-link'>
                    <div className='d-flex'>
                        <img src="/images/group.svg" alt="groups" className='me-3' />
                        <div>
                            <p className='mb-0 fw-bold'>{t('teacher.sidebar.groups')}</p>
                            <p className='mb-0 text-muted small'>{t('teacher.sidebar.groupsdescription')}</p>
                        </div>
                    </div>
                </Nav.Link>
                <Nav.Link as={NavLink} to='/teacher/students' className='sidebar-link'>
                    <div className='d-flex'>
                        <img src="/images/users.svg" alt="students" className='me-3' />
                        <div>
                            <p className='mb-0 fw-bold'>{t('teacher.sidebar.students')}</p>
                            <p className='mb-0 text-muted small'>{t('teacher.sidebar.studentsdescription')}</p>
                        </div>
                    </div>
                </Nav.Link>
                <Nav.Link as={NavLink} to='/teacher/evaluations' className='sidebar-link'>
                    <div className='d-flex'>
                        <img src="/images/check-dashboard.svg" alt="evaluations" className='me-3' />
                        <div>
                            <p className='mb-0 fw-bold'>{t('teacher.sidebar.evaluations')}</p>
                            <p className='mb-0 text-muted small'>{t('teacher.sidebar.evaluationsdescription')}</p>
                        </div>
                    </div>
                </Nav.Link>
                <Nav.Link as={NavLink} to='/teacher/tasks' className='sidebar-link'>
                    <div className='d-flex'>
                        <img src="/images/document.svg" alt="tasks" className='me-3' />
                        <div>
                            <p className='mb-0 fw-bold'>{t('teacher.sidebar.tasks')}</p>
                            <p className='mb-0 text-muted small'>{t('teacher.sidebar.tasksdescription')}</p>
                        </div>
                    </div>
                </Nav.Link>
                <Nav.Link as={NavLink} to='/teacher/communications' className='sidebar-link'>
                    <div className='d-flex'>
                        <img src="/images/chat.svg" alt="communications" className='me-3' />
                        <div>
                            <p className='mb-0 fw-bold'>{t('teacher.sidebar.communications')}</p>
                            <p className='mb-0 text-muted small'>{t('teacher.sidebar.communicationsdescription')}</p>
                        </div>
                    </div>
                </Nav.Link>
                <Nav.Link as={NavLink} to='/teacher/calendar' className='sidebar-link'>
                    <div className='d-flex'>
                        <img src="/images/calendar.svg" alt="calendar" className='me-3' />
                        <div>
                            <p className='mb-0 fw-bold'>{t('teacher.sidebar.calendar')}</p>
                            <p className='mb-0 text-muted small'>{t('teacher.sidebar.calendardescription')}</p>
                        </div>
                    </div>
                </Nav.Link>
                <Nav.Link as={NavLink} to='/teacher/employment' className='sidebar-link'>
                    <div className='d-flex'>
                        <img src="/images/creditcard.svg" alt="employment" className='me-3' />
                        <div>
                            <p className='mb-0 fw-bold'>{t('teacher.sidebar.employment')}</p>
                            <p className='mb-0 text-muted small'>{t('teacher.sidebar.employmentdescription')}</p>
                        </div>
                    </div>
                </Nav.Link>
                <Nav.Link as={NavLink} to='/teacher/profile' className='sidebar-link'>
                    <div className='d-flex'>
                        <img src="/images/user.svg" alt="profile" className='me-3' />
                        <div>
                            <p className='mb-0 fw-bold'>{t('teacher.sidebar.profile')}</p>
                            <p className='mb-0 text-muted small'>{t('teacher.sidebar.profiledescription')}</p>
                        </div>
                    </div>
                </Nav.Link>
            </Nav>
        </div >
    )
}
